<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Groups" title="Groups" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list  page-subtitle">
									<div class="row">
										<div class="col-md-10 d-flex">
											<span style="font-size: 20px; font-weight: bolder;">Manage Groups</span>
										</div>
										<div class="col-md-2">
											<router-link :to="{ name: 'addgroup' }" class="btn btn-primary">Add Group</router-link>
										</div>
										
									</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
									<div class="row">
										<div class="col-md-9 d-flex">
											<label class="d-flex listing-length"><span>Show</span>
												<select class="form-select" v-model="listing_length" @change="fetchGroups()">
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="20">20</option>
												</select>
												<span>entries</span>
											</label>
										</div>
										
										<div class="col-md-3">
												<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchGroups()" />
										</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Title</th>
											<th>Location</th>
											<th>Latitude</th>
											<th>Longitude</th>
											<th>Status</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(groups.length)">
										<tr v-for="group in groups" :key="group.id">
											<td>
												{{ group.group_name }}
											</td>
											<td>
												{{ group.location }}
											</td>
											<td>
												{{ group.latitude }}
											</td>
											<td>
												{{ group.longitude }}
											</td>
											<td>
												<label v-if="group.status == 1">Active</label>
												<label v-else>Blocked</label>
											</td>
											<td>
												<router-link :to="{ name: 'sliders.groups.edit', params: { id: group.id } }" class="btn btn-primary btn-sm mt-2 me-1">Edit</router-link>

												<a class="btn btn-danger mt-2 me-1 btn btn-sm" @click="deactivateGroup(group)" v-if="group.status == 1">Deactivate</a>
												<a class="btn btn-success mt-2 me-1 btn btn-sm" @click="activateGroup(group)" v-else>Activate</a>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchGroups(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>


		
	</div>
</template>


<script>
	export default {
		name: "Groups",
		data() {
			return {
				groups: [],
				pagination: {},
				edit: false,
				group_status: {
					id: "",
					status: "",
				},
				keyword: "",
				listing_length: 10,
				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,
			};
		},
		mounted() {},

		created() {
			this.fetchGroups();
		},

		methods: {
			fetchGroups(page_url = null) {
				let url = "/api/admin/groups?limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.groups = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

			activateGroup(group) {
				this.activate = false;
				this.$swal({
							icon: 'warning',
							title:"Confirm",
							text:'Are you sure you want to activate this group?',
							showCancelButton: true,
							confirmButtonText: 'Yes',
							confirmButtonColor: '#e64942',
							cancelButtonText: 'No',
							position: "center",
							showConfirmButton: true,
							timer: '',
							toast: false,
							cancelButtonColor: '#efefef',
							}).then((result)=>{
							if(result.value){
								this.group_status.id = group.id;
								this.group_status.status = "1";
								this.updateGroupStatus();
							}
							
						});
			},

			// activateGroup(group) {
			// 	this.activate = false;
		    //     this.$bvModal.msgBoxConfirm('Are you sure you want to activate this group?', {
		    //         title: 'Confirm',
		    //         size: 'sm',
		    //         buttonSize: 'sm',
		    //         okVariant: 'danger',
		    //         okTitle: 'Yes',
		    //         cancelTitle: 'No',
		    //         footerClass: 'p-2',
		    //         hideHeaderClose: false,
		    //         centered: true
		    //     })
		    //     .then(value => {
		    //         this.activate = value
		    //         if(this.activate){
			// 			this.group_status.id = group.id;
			// 			this.group_status.status = "1";
			// 			this.updateGroupStatus();
			// 		}
		    //     })
		    //      .catch(err => {
		    //         console.log(err);
		    //     })
			// },
			deactivateGroup(group) {
				this.deactivate = false;
				this.$swal({
							icon: 'warning',
							title:"Confirm",
							text:'Are you sure you want to deactivate this group?',
							showCancelButton: true,
							confirmButtonText: 'Yes',
							confirmButtonColor: '#e64942',
							cancelButtonText: 'No',
							position: "center",
							showConfirmButton: true,
							timer: '',
							toast: false,
							cancelButtonColor: '#efefef',
							}).then((result)=>{
							if(result.value){
								this.group_status.id = group.id;
								this.group_status.status = "0";
								this.updateGroupStatus();
							}
						});
			},
			// deactivateGroup(group) {
			// 	this.deactivate = false;
		    //     this.$bvModal.msgBoxConfirm('Are you sure you want to deactivate this group?', {
		    //         title: 'Confirm',
		    //         size: 'sm',
		    //         buttonSize: 'sm',
		    //         okVariant: 'danger',
		    //         okTitle: 'Yes',
		    //         cancelTitle: 'No',
		    //         footerClass: 'p-2',
		    //         hideHeaderClose: false,
		    //         centered: true
		    //     })
		    //      .then(value => {
		    //         this.deactivate = value
		    //         if(this.deactivate){
			// 			this.group_status.id = group.id;
			// 			this.group_status.status = "0";
			// 			this.updateGroupStatus();
			// 		}
         	// 	})
         	// 	.catch(err => {
           	// 		console.log(err);
         	// 	})
			// },
			updateGroupStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/groups/status?group_id=" + this.group_status.id + "&status=" + this.group_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.fetchGroups(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},
		},
	};
</script>
